import axios from "axios";
import { HotspotDTO } from "../entities/hotspot.entity";
import getRandomFontClasses from "../utils/getRandomFontClasses";
import isEmpty from "lodash/isEmpty";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const getPastHotspots = async () => {
  const { data: response } = await axios.get(
    `${API_BASE_URL}/v1/hotspots/wall`,
    {
      headers: {
        "Cache-Control": "no-cache, no-store, must-revalidate",
        Pragma: "no-cache",
        Expires: "0",
      },
    },
  );
  var hotspotsList = response?.data?.hotspots;

  if (isEmpty(hotspotsList)) {
    return [];
  }

  hotspotsList = fillToNextPerfectSquare(hotspotsList);

  const hotspots = hotspotsList?.map((h, i) => parseRawData(h, i));
  return hotspots ?? [];
};

const parseRawData = (data, index) => {
  if (!data) {
    return null;
  }
  const params = {
    id: `${data.id}-${index}`,
    originalId: data.id, // Preserve the actual backend hotspot ID
    title: data.name,
    venue: data.venue,
    date: data.date,
    host: {
      id: data.host.id,
      name: data.host.name,
      profileImageUrl: data.host.profile_image_url,
    },
    inviteeCount: data.capacity,
    assets: data.assets,
    font: getRandomFontClasses(),
    shareCode: data.share_code, // Share code from backend
  };
  return new HotspotDTO(params);
};

const fillToNextPerfectSquare = (arr) => {
  const currentLength = arr.length;
  if (currentLength === 0) return [];

  const nextPerfectSquare = Math.ceil(Math.sqrt(currentLength)) ** 2;
  const itemsToAdd = nextPerfectSquare - currentLength;

  if (itemsToAdd === 0) return arr;

  const newItems = Array.from({ length: itemsToAdd }, () =>
    arr[Math.floor(Math.random() * currentLength)]
  );

  return [...arr, ...newItems];
};
